import React, { Component } from 'react';
import ReactSelect from '../../components/Select/ReactSelect';
import CustomInput from '../../components/CustomInput/CustomInput';
import Loading from '../../components/Loading/Loading';
import Api from '../../api/Api.js';
import CFPortalEndpoints from '../../api/PluginEndpoints/CFPortalEndpoints';
import Empty from '../../components/Empty/Empty';

export default class AllocateShortCode extends Component {
    state = {
        account: null,
        user: null,
        pushType: { label: 'Email', value: 'email' },
        url: '',

        loading: true,
        details: null,
        accountList: [],
        userList: [],
        userListLoading: false,

        error: false
    }

    pushTypeList = [
        { label: 'Email', value: 'email' },
        { label: 'API Push', value: 'api' }
    ]

    componentDidCatch = (e) => this.setState({ error: true }, () => console.error(e));

    componentDidMount() {
        Api.get(CFPortalEndpoints.accounts)
            .then(({ data }) => {
                var accountData = data;
                Api.get(CFPortalEndpoints.shortCodeDetails, { Short_Code: this.props.license.product_reference })
                    .then(({ data }) => {
                        this.setState({ 
                            accountList: accountData.map(acc => 
                                ({
                                    label: acc.Account_No + ' - ' + acc.Account_Name,
                                    value: acc.Account_ID
                                })
                            ),
                            account: { label: data.user.account.Account_No + ' - ' + data.user.account.Account_Name, value: data.user.Account_ID },
                            user: {},
                            loading: false
                        }, () => this.retrieveAccountUsers());
                    })
                    .catch(this.componentDidCatch)
            })
            .catch(this.componentDidCatch)
    }

    retrieveAccountUsers() {
        this.setState({ userListLoading: true }, () =>
            Api.get(CFPortalEndpoints.accountUsers, { Account_ID: this.state.account.value })
                .then(({ data }) => {
                    this.setState({ userList: [{ label: '', value: '' }], userListLoading: false })
                })
                .catch(this.componentDidCatch)
        )
    }

    render() {
        if(this.state.error) {
            return <div style={{ textAlign: 'center' }}><Empty title="So Sorry, something went wrong..." subtitle="We couldn't pick up your Short Code on Cellfind Portal" /></div>;
        }

        if (this.state.loading) {
            return <Loading />
        }

        return (
            <div>
                <h3>Assign on Cellfind Portal</h3>

                <ReactSelect
                    label="Cellfind Portal Account"
                    options={this.state.accountList}
                    value={this.state.account}
                    onChange={(value) => this.setState({ account: value })}
                    isSearchable
                />

                <ReactSelect
                    label="Cellfind Portal User"
                    options={this.state.userList}
                    value={this.state.user}
                    onChange={(value) => this.setState({ user: value })}
                    isSearchable
                    isLoading={this.state.userListLoading}
                    isDisabled={this.state.userListLoading}
                />

                <ReactSelect
                    label="Push Type"
                    options={this.pushTypeList}
                    value={this.state.pushType}
                    onChange={(value) => this.setState({ pushType: value })}
                    isSearchable
                />

                {
                    this.state.pushType.value === 'api' ?
                        <CustomInput
                            labelText={"Push URL"}
                            id="url"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => this.setState({ url: event.target.value }),
                                value: this.state.url,
                            }}
                        />
                        :
                        null
                }

                <article>NOTE: Changes can take up to 1 hour to take effect</article>
            </div>
        );
    }
}